export default "__VITE_ASSET__f5f5781a__"